import client from "@/client";

const base = client.defaults.baseURL;

/**
 * adds base url if it does not exist
 * @param url
 */
function addBaseURL(url) {
	if (!url) {
		console.trace("No URL");
		return url;
	}

	let newUrl = url;

	if (url.indexOf(base) == -1) {
		newUrl = base + url;
	}

	if (url.indexOf(base + "/") == -1) {
		newUrl = newUrl.replace(base + "/", base);
	}

	return newUrl;
}

export { addBaseURL };
